module.exports = "\r\n\r\n<ngx-loading-bar [color]=\"'red'\"></ngx-loading-bar>\r\n\r\n\r\n<router-outlet></router-outlet>"